<template>
  <el-pagination
    background
    layout="total, prev, pager, next, jumper"
    :total="total"
    :page-size="pageSize"
    :current-page="pageIndex"
    @current-change="handleCurrentChange"
  />
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    handleCurrentChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
    };
  },
};
</script>
<style lang="scss" scoped>
.el-pagination {
  margin: 30px 0;
  text-align: right;

  ::v-deep .el-pager {
    .active {
      background-color: #73a7ff !important;
    }

    li:not(.active):hover {
      color: #73a7ff;
    }
  }
}
</style>
